// App-wide date formatting. Standard display is dd Month yyyy (e.g. "10 October 2026").
// Birthdays & anniversaries use dd/mm only (see formatDayMonth).
const MONTHS = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];

function toDate(v) {
  if (!v) return null;
  // Date-only ISO strings are parsed in local time to avoid a timezone day-shift.
  if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d;
}

export function formatDate(v) {
  const d = toDate(v);
  if (!d) return typeof v === "string" ? v : "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatDateTime(v) {
  const d = toDate(v);
  if (!d) return "—";
  let h = d.getHours();
  const min = String(d.getMinutes()).padStart(2, "0");
  const ap = h < 12 ? "am" : "pm";
  h = ((h + 11) % 12) + 1;
  return `${formatDate(d)}, ${h}:${min} ${ap}`;
}

export function daysTo(v) {
  const d = toDate(v);
  if (!d) return null;
  const now = new Date();
  return Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) -
    new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
}

export function countdownLabel(v) {
  const n = daysTo(v);
  if (n === null) return "";
  if (n > 1) return `${n} days to go`;
  if (n === 1) return "Tomorrow";
  if (n === 0) return "Today";
  if (n === -1) return "Yesterday";
  return `${-n} days ago`;
}

// Birthdays & anniversaries — "DD Mon" (e.g. "10 Oct") from separate day/month numbers.
const MONTHS_ABBR = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export function formatDayMonth(day, month) {
  if (!day || !month) return "—";
  return `${String(day).padStart(2, "0")} ${MONTHS_ABBR[month] || ""}`.trim();
}
